import React from 'react';
import {
  ThemeProvider,
  createTheme,
  Box,
  Typography,
  Button,
  Container,
  CssBaseline,
} from '@mui/material';
import ConstructionIcon from '@mui/icons-material/Construction';
import logo from '../assets/logo-login.png'

/* ===================== THEME ===================== */
const theme = createTheme({
  palette: {
    primary: {
      main: '#19a438',
      dark: '#148a31',
      contrastText: '#ffffff',
    },
    secondary: {
      main: '#002a4b',
      dark: '#001f38',
      contrastText: '#ffffff',
    },
    background: {
      default: '#f4f7fa',
      paper: '#ffffff',
    },
    text: {
      primary: '#333333',
      secondary: '#7f8c8d',
    },
  },
  typography: {
    fontFamily: 'Vazir-Medium',
  },
});

/* ===================== PAGE ===================== */
const UnderConstructionPage = () => {
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />

      <Box
        sx={{
          minHeight: '100vh',
          display: 'flex',
          flexDirection: 'column',
          bgcolor: 'background.default',
        }}
      >
        {/* ===================== LOGO ===================== */}
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            py: { xs: 2, md: 3 },
            bgcolor: 'background.paper',
            borderBottom: '1px solid',
            borderColor: 'divider',
          }}
        >
          <Box
            component="img"
            src={logo} // <-- replace with your logo path
            alt="Company Logo"
            sx={{
              maxWidth: 388,
              width: '100%',
              height: 'auto',
              objectFit: 'contain',
            }}
          />
        </Box>

        {/* ===================== HEADER BAR ===================== */}
        <Box
          sx={{
            bgcolor: 'secondary.main',
            py: 2,
            textAlign: 'center',
          }}
        >
          {/* <Typography
            variant="h4"
            color="secondary.contrastText"
            fontWeight="bold"
          >
            Under Construction
          </Typography> */}
        </Box>

        {/* ===================== MAIN CONTENT ===================== */}
        <Container
          sx={{
            flex: 1,
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            py: 6,
          }}
        >
          <Box
            sx={{
              bgcolor: 'background.paper',
              border: '2px solid',
              borderColor: 'primary.main',
              borderRadius: 3,
              p: { xs: 3, md: 5 },
              textAlign: 'center',
              boxShadow: 4,
              maxWidth: 520,
              width: '100%',
            }}
          >
            <ConstructionIcon
              sx={{
                fontSize: 80,
                color: 'primary.main',
                mb: 2,
              }}
            />

            <Typography
              variant="h6"
              color="secondary.main"
              fontWeight="bold"
              gutterBottom
            >
              سایت در حال به روز رسانی است...
            </Typography>
{/* 
            <Typography
              variant="body1"
              color="text.primary"
              sx={{ mb: 3, direction:'ltr' }}
              
            >
              Site Updating...
            </Typography> */}

            {/* <Button
              variant="contained"
              color="primary"
              size="large"
            >
              Notify Me
            </Button> */}
          </Box>
        </Container>

        {/* ===================== FOOTER ===================== */}
        <Box
          sx={{
            bgcolor: 'secondary.dark',
            py: 2,
            textAlign: 'center',
          }}
        >
          <Typography
            variant="body2"
            color="secondary.contrastText"
          >
            {/* © 2026 Your Company •{' '} */}
            {/* <Box component="span" sx={{ color: 'primary.secondary' }}>
              تماس با ما : تهران، خیابان آزادی، خیابان خوش شمالی، انتهای کوچه کوروش زارعی راستگو پلاک 10 طبقه اول     02166582011       -     02166582380       -     info@vadialtohid.ir
            </Box> */}
          </Typography>
        </Box>
      </Box>
    </ThemeProvider>
  );
};

export default UnderConstructionPage;
